import { loadStripe, type Stripe } from '@stripe/stripe-js';

const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!publishableKey) {
  // Surfaced at boot so missing env is loud, not silent. Mirrors
  // `./supabase.ts` so a missing key fails fast instead of failing inside
  // a checkout modal mount where the surface is harder to diagnose.
  // eslint-disable-next-line no-console
  console.warn(
    '[penrose-web] VITE_STRIPE_PUBLISHABLE_KEY is not set. ' +
      'Copy .env.example to .env.local and fill it in.'
  );
}

/**
 * Module-level `loadStripe()` singleton. The official Stripe guidance is to
 * call `loadStripe` exactly once per page load (it pulls Stripe.js from the
 * CDN — sharing the promise across mounts dedupes the network fetch).
 *
 * `<Elements>` mounts at modal scope (it needs a `clientSecret` first), not
 * globally — so consumers `import { stripePromise } from '@/lib/stripe'` and
 * pass it to `<Elements stripe={stripePromise}>` only when the checkout modal
 * opens.
 */
export const stripePromise: Promise<Stripe | null> = loadStripe(
  publishableKey ?? ''
);
